/**
 * Some routing libs require urls without trailing slashes.
 */
export function removeTrailingSlash<T>(url: T): T | string {
    if (typeof url !== 'string') {
        return url;
    }
    if (url.endsWith('/')) {
        return url.slice(0, -1);
    }
    return url;
}
